import { PropsWithChildren, FC } from 'react';
import * as Sentry from '@sentry/react';

export const SentryProvider: FC<PropsWithChildren> = ({ children }) => {
  const sentryEnabled = import.meta.env.VITE_SENTRY_ENABLED === 'true';

  Sentry.init({
    enabled: sentryEnabled,
    integrations: [
      Sentry.browserProfilingIntegration(),
      Sentry.browserTracingIntegration(),
      Sentry.browserSessionIntegration(),
      Sentry.captureConsoleIntegration(),
      Sentry.replayIntegration({
        maskAllInputs: false,
        blockAllMedia: false,
        maskAllText: false,
      }),

      // TODO: This is temporary logging, can be removed later
      Sentry.httpContextIntegration(),
      Sentry.httpClientIntegration(),
    ],

    environment: import.meta.env.VITE_ENV_NAME,
    dsn: import.meta.env.VITE_SENTRY_DSN,

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: true,

    profilesSampleRate: 1.0,
    tracesSampleRate: 1.0,
  });

  return children;
};
